import validate from "validate.js";
import { isValidPhoneNumber } from "libphonenumber-js";

validate.validators.maliciousCode = function(value, options, key, attributes) {
    if (/(?:<[^>]+>|javascript:)/.test(value)) {
        return options.message
            || _t('kd.user.validate_message_minimum_plain_text', 'Oops! Please only use letters and numbers - special character combinations are not allowed.');
    }
};

validate.validators.presenceIf = function(value, options, key, attributes) {
    if (attributes[options.attribute] === options.value) {
        return validate.validators.presence(value, options);
    }
};

validate.validators.notDefault = function(value, options, key, attributes) {
    if (value === "") {
        return options.message || _t('user.cancellation.validate_required_bank_name', 'Bank is required.');
    }
};

validate.validators.visible = function(value, options, key, attributes) {
    const field = document.getElementById(key);
    if (field && field.offsetParent === null) {
        return null;
    }
    return validate.validators.presence(value, options);
};

validate.validators.cellphoneNumber = function(value, options, key, attributes) {
    const isPhoneNumber = isValidPhoneNumber(value, 'ZA');
    return isPhoneNumber ? null : options.message;
};

const constraints = {
    'decline_reasons[]': {
        presence: {
            message: '^' + _t('kd.user.validate_required_decline_reasons', 'Decline reason is required.')
        }
    },
    email: {
        presence: {
            message: '^' + _t('kd.user.validate_required_email', 'Email is required')
        },
        email: {
            message: '^' + _t('kd.user.validate_email', 'Please enter a valid email address')
        }
    },
    email_confirm: {
        presence: {
            message: '^' + _t("supplier.signup.please_re_type","Please re-type your email address")
        },
        equality: {
            attribute: "email",
            message: '^' + _t("supplier.please_ensure_email_match","Please ensure that both emails match")
        }
    },
    recipient_email: {
        visible: {
            message: '^' + _t('voucher.recipient_email_required', "Please enter recipient's email") + '.'
        },
        email: {
            message: '^' + _t('kd.user.validate_email', 'Please enter a valid email address') + '.'
        }
    },
    recipient_email_confirm: {
        presence: {
            message: '^' + _t('voucher.enter_confirm', 'Please confirm the recipient email')
        },
        equality: {
            attribute: "recipient_email",
            message: '^' + _t('voucher.check_email', "Please check that the recipient email is correct")
        }
    },
    recipient_name: {
        presence: {
            message: '^' + _t('voucher.recipient_name_required', "Please enter recipient's name")
        },
    },
    payer_name: {
        presence: {
            message: '^' + _t('voucher.your_name_required', 'Please enter your name')
        }
    },
    payer_email: {
        presence: {
            message: '^' + _t('voucher.your_email_required', 'Please enter your email')
        },
        email: {
            message: '^' + _t('user.enter_email_new', 'Please enter a valid email address')
        }
    },
    full_name: {
        presence: {
            message: '^' + _t('kd.user.validate_required_name', 'Name is required.')
        },
    },
    firstname: {
        presence: {
            message: '^' + _t("supplier.signup.please_enter_first_name","Please enter your first name")
        },
        format: {
            pattern: "^[a-zA-ZÀ-ÿ\\s-]+$",
            message: '^' + _t("supplier.signup.invalid_first_name_no_num_or_special", "First name can only contain letters, spaces and hyphens")
        }
    },
    fname: {
        presence: {
            message: '^' + _t("supplier.signup.please_enter_first_name","Please enter your first name")
        }
    },
    lastname: {
        presence: {
            message: '^' + _t("supplier.signup.please_enter_surname","Please enter your surname")
        },
        format: {
            pattern: "^[a-zA-ZÀ-ÿ\\s-]+$",
            message: '^' + _t("supplier.signup.invalid_last_name_no_num_or_special", "Surname can only contain letters, spaces and hyphens")
        }
    },
    surname: {
        presence: {
            message: '^' + _t("supplier.signup.please_enter_surname","Please enter your surname")
        }
    },
    id_number: {
        presence: {
            message: '^' + _t("user.please_enter_id","Please enter your ID or passport number")
        },
        format: {
            pattern: "^(?=.*[0-9]).+$",
            message: '^' + _t("user.please_enter_valid_id","Please enter a valid ID or passport number")
        }
    },
    address: {
        presence: {
            message: '^' + _t('kd.user.validate_required_address', 'Address is required.')
        },
        length: {
            minimum: 5,
            tooShort: '^' + _t('kd.user.validate_required_address_minimum_5', 'Address needs to have 5 letters or more.')
        }
    },
    traveller_type: {
        presence: {
            message: '^' + _t('kd.user.validate_required_traveller_type', 'Traveller type is required.')
        },
    },
    voucher_code: {
        presence: {
            message: '^' + _t('kd.user.validate_required_voucher', 'Voucher is required.')
        }
    },
    voucher_amount: {
        presence: {
            message: '^' + _t('voucher.min_amount', 'Please enter an amount from R200')
        },
        numericality: {
            onlyInteger: true,
            notInteger: '^' + _t('voucher.enter_digits', 'Please enter a whole number'),
            greaterThanOrEqualTo: 200,
            notGreaterThanOrEqualTo: '^' + _t('voucher.min_amount', 'Please enter an amount from R200'),
            lessThanOrEqualTo: 25000,
            notLessThanOrEqualTo: '^' + _t('voucher.max_amount_25000', 'Please enter an amount up to R25 000')
        },
    },
    extension_reason: {
        presence: {
            message: '^' + _t('kd.user.validate_required_extension_reason', 'Extension reason is required.')
        },
        length: {
            minimum: 5,
            tooShort: '^' + _t('kd.user.validate_required_extension_minimum_5', 'Extension reason needs to have 5 letters or more.')
        },
        maliciousCode: {
            message: '^' + _t('kd.user.validate_message_minimum_plain_text', 'Oops! Please only use letters and numbers - special character combinations are not allowed.')
        }
    },
    cancellation_reason_text_area: {
        presenceIf: {
            attribute: 'cancellation_reason',
            value: 'other',
            message: '^' + _t('kd.user.validate_required_reason', 'Reason is required.')
        },
        length: {
            minimum: 5,
            tooShort: '^' + _t('kd.user.cancellation_reason', 'Reason needs to have 5 letters or more.')
        }
    },
    account_holder: {
        visible: {
            message: '^' + _t('user.cancellation.validate_required_account_holder', 'Account holder is required.')
        }
    },
    bank: {
        visible: {
            message: '^' + _t('user.cancellation.validate_required_bank_name', 'Bank is required.')
        },
        notDefault: {
            message: '^' + _t('user.cancellation.validate_required_bank_name', 'Bank is required.')
        }
    },
    account_number: {
        visible: {
            message: '^' + _t('user.cancellation.validate_required_account_number', 'Account number is required.')
        },
        numericality: {
            onlyInteger: true,
            message: '^' + _t('kd.user.numbers_only','Please enter numbers only') + '.'
        },
        length: {
            maximum: 13,
            tooShort: '^' + _t('user.account_number_length', 'The account number should not have more than 13 digits') + '.'
        }
    },
    branch: {
        numericality: {
            onlyInteger: true,
            message: '^' + _t('kd.user.numbers_only','Please enter numbers only') + '.'
        }
    },
    pass: {
        presence: {
            message: '^' + _t("user.enter_pass","Please enter a password")
        },
        length: {
            minimum: 6,
            tooShort: '^' + _t("login.enter_valid_password","Password must be at least 6 characters")
        }
    },
    password_current: {
        presence: {
            message: '^' + _t("user.enter_pass","Please enter a password")
        },
        length: {
            minimum: 6,
            tooShort: '^' + _t("login.enter_valid_password","Password must be at least 6 characters")
        }
    },
    password: {
        presence: {
            message: '^' + _t("user.enter_pass","Please enter a password")
        },
        length: {
            minimum: 6,
            tooShort: '^' + _t("login.enter_valid_password","Password must be at least 6 characters")
        }
    },
    password_repeat: {
        presence: {
            message: '^' + _t("user.enter_pass","Please enter a password")
        },
        length: {
            minimum: 6,
            tooShort: '^' + _t("login.enter_valid_password","Password must be at least 6 characters")
        },
        equality: {
            attribute: "password",
            message: '^' + _t("kd.global.login.password_repeat","Password must be the same to reset")
        }
    },
    terms: {
        presence: {
            message: '^' + _t("supplier.signup.must_accept","You must accept the terms and conditions.")
        },
    },
    phone: {
        presence: {
            message: '^' + _t("supplier.signup.please_enter_phone_num","Please enter your phone number (numbers only)")
        },
        numericality: {
            onlyInteger: true,
            message: '^' +  _t("supplier.please_enter_num_only","Please enter numbers only")
        },
        length: {
            minimum: 6,
            tooShort: '^' + _t("mobile.enquiry.error_phone_length","The number you've entered is too short."),
            maximum: 15,
            tooLong: '^' + _t("mobile.enquiry.error_phone_length_long","The number you've entered is too long.")
        },
    },
    cellphone: {
        presence: {
            message: '^' + _t("supplier.signup.please_enter_phone_num","Please enter your phone number (numbers only)")
        },
        numericality: {
            onlyInteger: true,
            message: '^' +  _t("supplier.please_enter_num_only","Please enter numbers only")
        },
        length: {
            minimum: 10,
            tooShort: '^' + _t("mobile.enquiry.error_phone_length","The number you've entered is too short."),
            maximum: 15,
            tooLong: '^' + _t("mobile.enquiry.error_phone_length_long","The number you've entered is too long.")
        },
        cellphoneNumber: {
            message: '^' + _t("mobile.verify.invalid_number", "The number you've entered is invalid"),
        },
    },
    number: {
        presence: {
            message: '^' + _t('kd.user.validate_required_card_number_reason', 'Card number is required.')
        },
    },
    expiry_month: {
        presence: {
             message: '^' + _t('kd.user.validate_required', 'Required')
            //message: '^' + _t('kd.user.validate_required_expiry_month', 'Expiry month is required.')
        },
    },
    expiry_year: {
        presence: {
            message: '^' + _t('kd.user.validate_required', 'Required')
            //message: '^' + _t('kd.user.validate_required_expiry_year', 'Expiry year is required.')
        },
    },
    cvv: {
        presence: {
            message: '^' + _t('kd.user.validate_required', 'Required')
        },
        numericality: {
            onlyInteger: true,
            message: '^' + _t('kd.user.validate_invalid', 'Invalid')
        }
    },
    chat_message: {
        presence: {
            message: '^' + _t('kd.user.validate_required_message', 'Message is required.')
        },
        length: {
            minimum: 5,
            tooShort: '^' + _t('kd.user.validate_required_message_minimum_5', 'Message needs to have 5 letters or more.')
        },
        maliciousCode: {
            message: '^' + _t('kd.user.validate_message_minimum_plain_text', 'Oops! Please only use letters and numbers - special character combinations are not allowed.')
        }
    },
    delivery_date: {
        presence: {
            message: '^' + _t('voucher.delivery_date', 'Please select a delivery date')
        },
    },
    stars_value: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_service: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_clean: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        },
    },
    stars_location: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_safety: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    travel_type: {
        presence: {
            message: '^' + _t("reviews.travel_type_error", "Select your travel type.")
        }
    },
    recommend: {
        presence: {
            message: '^' + _t("reviews.yes_or_no", "Please select either 'Yes' or 'No'.")
        }
    },
    charged_extra: {
        presence: {
            message: '^' + _t("reviews.yes_or_no", "Please select either 'Yes' or 'No'.")
        }
    },
    photos_accurate: {
        presence: {
            message: '^' + _t("reviews.yes_or_no", "Please select either 'Yes' or 'No'.")
        }
    },
    review_summary: {
        presence: {
            message: '^' + _t('kd.user.validate_required', 'Required')
        }
    },
    review_full: {
        presence: {
            message: '^' + _t('kd.user.validate_required', 'Required')
        },
        length: {
            minimum: 20,
            tooShort: '^' + _t("reviews.minimum_20_charcters", "Minimum 20 characters")
        }
    },
    breakfast_radio: {
        presence: {
            message: '^' + _t("reviews.yes_no_not_avail", "Please select either 'Yes', 'No' or 'Not Available'.")
        }
    },
    wifi_radio: {
        presence: {
            message: '^' + _t("reviews.yes_no_not_avail", "Please select either 'Yes', 'No' or 'Not Available'.")
        }
    },
    conference_radio: {
        presence: {
            message: '^' + _t("reviews.yes_no_not_avail", "Please select either 'Yes', 'No' or 'Not Available'.")
        }
    },
    stars_work_appropriate: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_facilities: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_breakfast: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_wifi: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_conference: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    charged_extra_reason: {
        presence: {
            message: '^' + _t('kd.user.validate_required', 'Required')
        }
    },
    photos_inaccurate_reason: {
        presence: {
            message: '^' + _t('kd.user.validate_required', 'Required')
        },
        length: {
            minimum: 20,
            tooShort: '^' + _t("reviews.minimum_20_charcters", "Minimum 20 characters")
        }
    },
    use_company_again: {
        presence: {
            message: '^' + _t("reviews.yes_or_no", "Please select either 'Yes' or 'No'.")
        }
    },
    recommend_company: {
        presence: {
            message: '^' + _t("reviews.yes_or_no", "Please select either 'Yes' or 'No'.")
        }
    },
    recommend_company_nps: {
        presence: {
            message: '^' + _t("kd.reviews.select_0_to_10", "Please select a number between 0 and 10.")
        }
    },
    stars_user_friendliness: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_customer_service: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    stars_convenience: {
        presence: {
            message: '^' + _t("reviews.select_grading", "Select a star grading.")
        }
    },
    display_review_publicly: {
        presence: {
            message: '^' + _t("reviews.yes_or_no", "Please select either 'Yes' or 'No'.")
        }
    },
    usage_limit: {
        presence: {
            message: '^' + _t('kd.user.validate_required', 'Required')
        }
    },
    bio: {
        length: {
            maximum: 500,
            tooLong: '^' + _t('kd.user.bio_too_long', 'Please enter a bio of 500 characters or less.')
        }
    },
    sanlam_login: {
        numericality: {
            onlyInteger: true,
            message: '^' +  _t("kd.user.numbers_only", "Please enter numbers only")
        },
        length: {
            minimum: 10,
            tooShort: '^' + _t("kd.user.number_too_short", "The number you've entered is too short."),
        }
    },
    friend_name: {
        presence: {
            message: '^' + "Please enter your friend's name"
        }
    },
    friend_email: {
        presence: {
            message: '^' + "Please enter your friend's email address"
        }
    }
};

/**
 * @param {HTMLFormElement} form
 */
function handleFormSubmit(form) {
    ignoreFormNoValidateInputs(form);

    // validate the form against the constraints
    const constraints = determineFormSpecificConstraints(form);

    const errors = validate(form, constraints);

    // then we update the form to reflect the results
    showErrors(form, errors || {});
    return !errors;
}

/**
 * @param {HTMLInputElement} input
 */
function resetInputError(input) {

    // We loop through all the inputs and remove the errors for that input

    // Since the errors can be null if no errors were found we need to handle
    let inputEl = /** @type {HTMLInputElement} */ (input);

    removeErrorsForInput(inputEl);
}

// Updates the inputs with the validation errors

/**
 * @param {HTMLFormElement} form
 * @param {{ [x: string]: any; }} errors
 */
function showErrors(form, errors) {
    // We loop through all the inputs and show the errors for that input,
    // excluding hidden inputs or inputs with formnovalidate attribute
    const isReviewForm = ['js-review-accomm-form', 'js-review-company-form'].includes(form.id);
    var elList = form.querySelectorAll("input[name]:not([type=hidden]):not([formnovalidate]), select[name]:not([formnovalidate]), textarea[name]:not([formnovalidate])")

    if (isReviewForm) {
        elList = [...elList, ...form.querySelectorAll(".js-rating-input")];
    }
    elList.forEach( input => {
        // Since the errors can be null if no errors were found we need to handle
        let inputEl = /** @type {HTMLInputElement} */ (input);

        if (inputEl.type !== 'radio' || isReviewForm) {
            showErrorsForInput(inputEl, errors && errors[inputEl.name]);
        }
    });
}

/**
 * @param {HTMLFormElement} form
 * @param {boolean} toggle
 */
function toggleFormInputs(form, toggle) {
    const elList = form.querySelectorAll("input[name], select[name], textarea[name]")
    elList.forEach( input => {
        // Since the errors can be null if no errors were found we need to handle
        let inputEl = /** @type {HTMLInputElement} */ (input);

        if (inputEl.type !== 'radio') {
           inputEl.disabled = toggle;
        }
    });
}


function validationEventListener() {
    if (typeof event !== "undefined") {
        const inputEl = /** @type {HTMLInputElement} */ (event.target);
        // Don't validate inputs with formnovalidate attribute
        if (inputEl.hasAttribute("formnovalidate") === false || inputEl.getAttribute("formnovalidate") === "false") {
            const nearestFormEl = inputEl.closest('form');

            // Determine the constraints for the specifc form
            const newConstraints = determineFormSpecificConstraints(nearestFormEl);

            // If no contraints don't validate

            if (newConstraints.constructor === Object && Object.entries(newConstraints).length > 0) {
                const errors = validate(nearestFormEl, newConstraints) || {};
                showErrorsForInput(this, errors[this.name]);
            }
        }
    }
}


/**
 * Shows the errors for a specific input
 * @param {HTMLInputElement} input
 * @param {any} errors
 **/
function showErrorsForInput(input, errors) {
   // This is the root of the input
    let formGroup = /** @type {HTMLDivElement} */ (closestParent(input.parentNode, "form-group"));

    // Find where the error messages will be insert into
    /** @type {HTMLDivElement} */
    let messages;

    if (formGroup !== null && formGroup.querySelector(".form-messages") !== null) {
        messages = formGroup.querySelector(".form-messages");
    } else {
        messages = document.createElement("div");
        messages.classList.add('form-messages');
    }

    formGroup.appendChild(messages);
    // First we remove any old messages and resets the classes
    resetFormGroup(formGroup);

    // If we have errors
    if (errors) {
        // we first mark the group has having errors
        formGroup.classList.add("has-error");
        // then we append ONLY the first error
        addError(messages, errors[0]);
    } else {
        // otherwise we simply mark it as success
        formGroup.classList.add("has-success");
    }
}

/**
 * Removes the errors for a specific input
 * @param {HTMLInputElement} input
 **/
function removeErrorsForInput(input) {
    // This is the root of the input
    let formGroup = /** @type {HTMLDivElement} */ (closestParent(input.parentNode, "form-group"));

    // First we remove any old messages and resets the classes
    resetFormGroup(formGroup);

}

// Recusively finds the closest parent that has the specified class
function closestParent(child, className) {
    if (!child || child == document) {
        return null;
    }
    if (child.classList.contains(className)) {
        return child;
    } else {
        return closestParent(child.parentNode, className);
    }
}


function resetFormGroup(formGroup) {
    // Remove the success and error classes
    formGroup.classList.remove("has-error");
    formGroup.classList.remove("has-success");
    // and remove any old messages
    let elError = formGroup.querySelectorAll(".form-message.form-error");
    elError.forEach( el => {
        el.parentNode.removeChild(el);
    });
}

// Adds the specified error with the following markup
// <p class="help-block error">[message]</p>
/**
 * @param {HTMLDivElement} messages
 * @param {string} error
 */
function addError(messages, error) {
    var block = document.createElement("div");
    block.classList.add("form-message");
    block.classList.add("form-error");
    block.innerText = error;
    messages.appendChild(block);
}

/**
 * Determine the constraints for the specifc form
 * @param {HTMLFormElement} form
 *
 */
function determineFormSpecificConstraints(form) {
    const formValues = validate.collectFormValues(form);
    let newConstraints = {};

    for (const key in formValues) {
        for (const k in constraints){
            if (k === key) {
                newConstraints[key] = constraints[key];
            }
        }
    }

    return newConstraints;
}

/**
 * Determine which inputs ignore for validation
 *
 * Use `formnovalidate` attribute in our HTML (this is the correct attribute)
 * and convert to data-ignore attribute on for submission for validate.js to use correctly
 *
 * @param {HTMLFormElement} form
 */
function ignoreFormNoValidateInputs(form) {
    const inputList = form.querySelectorAll("input[name], select[name], textarea[name]");

    inputList.forEach(input => {
        if (input.hasAttribute("formnovalidate") && input.getAttribute("formnovalidate") !== "false") {
            input.setAttribute("data-ignored", "true");
        } else {
            input.removeAttribute("data-ignored");
        }
    });
}

function resetValidationInputCheck() {
    const inputs = /** @type {NodeListOf<HTMLInputElement>} */ document.querySelectorAll("input, textarea, select");
    inputs.forEach(input => {
        input.removeEventListener("change", validationEventListener, false);
        input.removeEventListener("focusout", validationEventListener, false);

        input.addEventListener("change", validationEventListener, false);
        input.addEventListener("focusout", validationEventListener, false);
    });
}

export { handleFormSubmit, toggleFormInputs, validationEventListener, showErrorsForInput, resetInputError, resetValidationInputCheck };
